import {useSelector} from 'react-redux'
import {User} from '@hconnect/apiclient'
import {parsePhoneNumber} from '@hconnect/tuc-processes/utils/phoneNumberUtils'
import {getUserProfile} from '../../UserProfile/UserProfile.selectors'
import {AppState} from '../../Root.store'
import {useState} from 'react'
import {JobSiteCreationModal} from './JobSiteCreationModal'
import {
  ShipToCreationData,
  ShipToCreationProvider,
  useShipToCreationForm
} from '@hconnect/tuc-processes/shipToCreation'
import {OrderIntakeSite} from '../rmc/orderIntake/types/OrderIntakeSite.types'
import {JobSiteCreationProcessContextProvider} from './JobSiteCreationProcessContext'

export const JobSiteCreationProcess = (
  props: ShipToCreationData & {
    onClose: () => void
    onCreateNewOrder: (site: OrderIntakeSite) => void
  }
) => {
  const userProfile = useSelector<AppState, User | null>(
    (state) => getUserProfile(state).userProfile
  )
  const {shipToCreationForm} = useShipToCreationForm({
    siteContact: {
      name: userProfile?.name ?? '',
      phoneNumber: parsePhoneNumber(
        userProfile?.mobileNumber ?? '',
        userProfile?.country ?? props.country
      )
    }
  })
  const [open, setOpen] = useState(true)

  const onClose = () => {
    setOpen(false)
    props.onClose()
  }

  return (
    <ShipToCreationProvider processData={props} shipToCreationForm={shipToCreationForm}>
      <JobSiteCreationProcessContextProvider onCreateNewOrder={props.onCreateNewOrder}>
        <JobSiteCreationModal open={open} onClose={onClose} />
      </JobSiteCreationProcessContextProvider>
    </ShipToCreationProvider>
  )
}
